module.exports = __webpack_public_path__ + "files/3b16d4c38f875a7b2e16bdb5b310ae6f.png";